<div class="title-container" mat-dialog-title>
  <h2 class="title">Keyboard Shortcuts</h2>
  <button class="close-button" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="dialog-content">
  <mat-tab-group mat-stretch-tabs="false">
    <mat-tab *ngFor="let tab of config.tabs" [label]="tab.name">
      <div
        class="tab-container default-anchors"
        #scrollContainer
        (scroll)="onScroll()"
      >
        <sama-scroll-section-navigation
          [items]="getScrollingItems(tab)"
          [scrollContainer]="scrollContainer"
          [sidebarSize]="150"
          [sticky]="true"
          sidebarPosition="left"
        >
          <div
            *ngFor="let section of tab.sections"
            [id]="getSectionId(tab.name, section.name)"
            class="section"
          >
            <h3 class="section-title">{{section.name}}</h3>
            <ng-container *ngFor="let shortcut of section.shortcuts">
              <div *ngIf="shortcut.key" class="section-shortcut">
                <span data-id="shortcutName">{{shortcut.name}}</span>
                <div data-id="shortcutKeyContainer" class="shortcut">
                  <ng-container
                    *ngFor="let shortcutArray of formatKey(tab.name, shortcut.name, shortcut.key)"
                  >
                    <span class="key" *ngFor="let key of shortcutArray"
                      >{{key}}</span
                    >
                    <span class="separator">,</span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </sama-scroll-section-navigation>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
